// ── Goccia Group — main.js per Shopify ──────────────────────
// Caricare in: assets/goccia-group.js
// Richiamare con: {{ 'goccia-group.js' | asset_url | script_tag }}

document.addEventListener('DOMContentLoaded', () => {

  // ── Nav scroll effect ──────────────────────────────────────
  const nav = document.querySelector('.nav');
  if (nav) {
    const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ── Mobile burger ──────────────────────────────────────────
  const burger   = document.querySelector('.nav__burger');
  const navLinks = document.querySelector('.nav__links');
  if (burger && navLinks) {
    burger.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('nav__links--open');
      burger.setAttribute('aria-expanded', String(isOpen));
    });
  }

  // ── Scroll reveal su elementi Goccia Group ─────────────────
  if ('IntersectionObserver' in window) {
    const targets = document.querySelectorAll('.gg-will-animate');
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('gg-is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -24px 0px' });

    targets.forEach((el, i) => {
      const siblings = Array.from(
        el.parentElement.querySelectorAll(':scope > ' + el.tagName)
      );
      const idx = siblings.indexOf(el);
      if (idx > 0) el.style.transitionDelay = `${idx * 0.07}s`;
      io.observe(el);
    });
  }

});
